import { Modal } from "@circleco/compass/components/Modal";
import type { ReactNode } from "react";
import { useFormState } from "react-hook-form";

import { t } from "@/i18n-js/instance";
import { useModal } from "@/react/components/Layout/ModalManagerProvider";
import { useDiscardChangesModal } from "@/react/components/Modals/DiscardChangesModal";

interface EditModalShellProps {
  children: ReactNode;
  disabled: boolean;
  formId: string;
}

export const EditModalShell = ({
  children,
  formId,
  disabled,
}: EditModalShellProps) => {
  const modal = useModal();
  const discardChangesModal = useDiscardChangesModal();
  const { isSubmitting, isDirty } = useFormState();

  const handleClose = () => {
    if (!isDirty) {
      void modal.hide();
      return;
    }
    void discardChangesModal.show({
      onConfirm: () => void modal.hide(),
    });
  };

  return (
    <Modal.Root
      open={modal.visible}
      onOpenChange={open => {
        if (!open) handleClose();
      }}
      onOpenChangeComplete={open => {
        if (!open) modal.remove();
      }}
      size="lg"
    >
      <Modal.Content>
        <Modal.Header title={t("comments.edit.form.title")} showCloseButton />
        <Modal.Body>{children}</Modal.Body>
        <Modal.Footer
          secondaryAction={{
            label: t("comments.edit.actions.cancel"),
            onClick: handleClose,
            shouldCloseModal: false,
          }}
          primaryAction={{
            type: "submit",
            form: formId,
            label: t("comments.edit.actions.save_changes"),
            loading: isSubmitting,
            disabled,
          }}
        />
      </Modal.Content>
    </Modal.Root>
  );
};
